<template>
    <div class="form-group">
        <div 
            class="input-group date" 
            data-target-input="nearest" 
            :id="id"
        >
            <input 
                type="text" 
                class="form-control datetimepicker-input" 
                :data-toggle="disabled ? null : 'datetimepicker'" 
                :data-target="disabled ? null : '#'+id" 
                placeholder="Choose date..."
                :disabled="disabled"
                v-bind="$attrs"
            >
            <div 
                class="input-group-append" 
                :data-target="disabled ? null : '#'+id" 
                :data-toggle="disabled ? null : 'datetimepicker'"
            >
                <div class="input-group-text">
                    <i class="fa fa-calendar" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
require("tempusdominus-bootstrap-4");

export default {
    name: "Datetimepicker",

    props: {
        value: {
            type: [String, Object],
            default: '',
            required: false
        },
        options: {
            required: false,
            type: Object,
            default: () => {
                return {
                    icons: {
                        time: 'fa fa-clock'
                    },
                };
            }
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            id: null,
            updatingDatepicker: false,
        };
    },

    watch: {
        value: { 
            handler() {
                this.updateDatepicker();
            }
        },
        options: {
            handler() {
                this.updateDatepicker();
            },
            deep: true,
        }
    },

    mounted: function () {
        this.id = "datepicker" + this._uid;
        const vm = this;
        window.$($ => {
            const el = $("#" + this.id);
            el.datetimepicker(this.options);
            $(el).on("change.datetimepicker", e => {
                if (vm.disabled || vm.updatingDatepicker) {
                    return;
                }
                vm.inputChanged(e.date);
            });
            vm.updateDatepicker();
            vm.inputChanged(this.value);
        });

    },

    methods: {
        inputChanged: function (date) {
            this.$emit("input", date);
        },
        dateWithinMinDate: function (value) {
            if (!value || !this.options || !this.options.minDate) {
                return value;
            }
            if (!window.moment.isMoment(value) || !window.moment.isMoment(this.options.minDate)) {
                return value;
            }
            if (value.isBefore(this.options.minDate, 'day')) {
                return this.options.minDate.clone();
            }
            return value;
        },
        shouldEmitAdjustedDate: function (dateToSet) {
            if (!dateToSet || dateToSet === this.value) {
                return false;
            }
            if (window.moment.isMoment(dateToSet) && window.moment.isMoment(this.value)) {
                return !dateToSet.isSame(this.value, 'day');
            }
            return true;
        },
        updateDatepicker: function () {
            window.$($ => {
                const el = $("#" + this.id);
                this.updatingDatepicker = true;
                const dateToSet = this.dateWithinMinDate(this.value);
                el.datetimepicker("options", this.options);
                el.datetimepicker("date", dateToSet || '');
                this.updatingDatepicker = false;
                if (this.shouldEmitAdjustedDate(dateToSet)) {
                    this.inputChanged(dateToSet);
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DateTimePickerComponent.vue